<div class="modal-content">
	<form [formGroup]="sendForm">
		<div class="modal-header">
			<h5 data-testid="SUBSYS2_SENDMODAL_TITLE_TXT" class="modal-title">
				{{ labels().PLAN_SEND_MODAL_COMPONENT_TITLE }}
			</h5>
			<button type="button" class="hide-focus"></button>
		</div>
		<div class="modal-body">

			<div class="panel alert mb-3">
				<div class="state-icon"><i class="material-icons md-18">report_problem</i></div>
				<p data-testid="SUBSYS2_SENDMODAL_LIABILITY_TXT">{{ labels().PLAN_SEND_MODAL_COMPONENT_MESSAGE }}</p>
			</div>

			<div class="row">
				<div class="col-7">
					<div class="form-group pb-4">
						<label data-testid="SUBSYS2_SENDMODAL_PLANID_LBL" for="PlanId" class="d-inline-block">
							{{ labels().PLAN_SEND_MODAL_COMPONENT_PLAN_ID }}
						</label>
						<span data-testid="SUBSYS2_SENDMODAL_PLANID_TXT" class="ms-4">{{ planId }}</span>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-12">
					<div class="form-group">
						<label data-testid="SUBSYS2_SENDMODAL_USERNAME_LBL" for="UserName">
							{{ labels().PLAN_SEND_MODAL_COMPONENT_USERNAME }} * &nbsp;
							<span style="text-transform: none">{{ labels().PLAN_SEND_MODAL_COMPONENT_USERNAME_DESC }} </span>
						</label>
						<input data-testid="SUBSYS2_SENDMODAL_USERNAME_INPUT" type="text" autocomplete="off"
							class="form-control col-7" id="UserName" formControlName="userName"
							[placeholder]="labels().PLAN_SEND_MODAL_COMPONENT_USERNAME" (change)="trimUserName()"
							[class]="{'is-valid': sendForm.controls.userName.valid && sendForm.controls.userName.touched, 'is-invalid': sendForm.controls.userName.invalid && sendForm.controls.userName.touched}"
							[appFormValidationMsg]="errorMsgs.userName" />
						@if (sendForm.controls.userName.errors?.[username_caseVersionMismatch]) {
						<div class="invalid-feedback">{{ caseVersionMismatchError }}</div>
						}
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-12">
					<div class="form-group">
						<label data-testid="SUBSYS2_SENDMODAL_NOTES_LBL" for="Notes">
							{{ labels().PLAN_SEND_MODAL_COMPONENT_NOTES }}
						</label>
						<input data-testid="SUBSYS2_SENDMODAL_NOTES_INPUT" type="text" autocomplete="off" class="form-control"
							id="Notes" formControlName="notes" [placeholder]="labels().RECEIVED_CLONE_MODAL_COMPONENT_PLAN_NOTES"
							[class]="{'is-valid': sendForm.controls.notes.valid && sendForm.controls.notes.touched, 'is-invalid': sendForm.controls.notes.invalid && sendForm.controls.notes.touched}"
							[appFormValidationMsg]="errorMsgs.notes" />
					</div>
				</div>
			</div>

		</div>
		<div class="modal-footer">
			<button data-testid="SUBSYS2_SENDMODAL_CANCEL_BTN" type="button" class="btn btn-secondary-outline"
				(click)="activeModal.dismiss()">
				{{ labels().PLAN_SEND_MODAL_COMPONENT_CANCEL_BUTTON }}
			</button>
			<button data-testid="SUBSYS2_SENDMODAL_CONFIRM_BTN" type="button" class="btn btn-primary"
				[disabled]="!sendForm.valid || isSaving" (click)="confirm()">
				{{ labels().PLAN_SEND_MODAL_COMPONENT_CONFIRM_BUTTON }}
			</button>
		</div>
	</form>
</div>